<template>
  <div class="home">
    <nav-bar></nav-bar>
    <div class="content">
      <div :class="['aside', opened ? 'closeNav': '']">
        <transition name="el-fade-in-linear">
          <side-bar>
          </side-bar>
        </transition>
      </div>
      <div :class="['main', opened ? 'closeBar': '']">
        <Breadcrumb class=""></Breadcrumb>
        <transition name="fade-transform" mode="out-in">
            <router-view ></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar.vue'
import SideBar from '@/components/SideBar.vue'
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
export default {
  name: 'Home',
  data () {
    return {
      isCollapse: true
    }
  },
  computed: {
    ...mapGetters(['opened'])
  },
  components: {
    NavBar,
    SideBar,
    Breadcrumb
  },
  methods: {
    handleOpen (key, keyPath) {}
  },
  mounted () {
    // console.log(this.opened)
  }
}
</script>
<style lang="less" scoped>
  .home {
    height: 100%;
    background-color: white;
    position: relative;
    .content {
      display: flex;
      flex-direction: row;
      height: calc(100vh - 60px);
      width: 100%;
      .aside {
        // width: 205px;
        /*overflow-y: scroll;*/
        width: 200px;
        height: calc(100% - 60px);
        position: fixed;
        bottom: 0;
        left: 0;
        overflow: hidden;
        transition: width 0.3s;
        z-index: 999;
        .el-scrollbar {
          height: 100%;
          .el-scrollbar__wrap {
            overflow-x: hidden !important;
          }
        }
      }
      .main{
        transition: all 0.3s;
        height: 100%;
        margin-left: 200px;
        width: calc(100% - 200px);
        overflow-y: scroll;
        // padding: 15px;
      }
    }
  }
  .closeNav{
    width: 64px !important;
  }
  .closeBar{
    margin-left: 64px !important;
    width: calc(100% - 64px) !important;
  }
</style>
